import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.003 2.17a.95.95 0 0 0-.945.946v2.89h19.884v-2.89a.95.95 0 0 0-.945-.946zm13.645 5.836h5.294v3.836h-5.294zm-1 5.836H9.353v3.642h3.955a1 1 0 0 1 0 2H3.003a2.95 2.95 0 0 1-2.945-2.946V3.116A2.95 2.95 0 0 1 3.003.17h17.994a2.95 2.95 0 0 1 2.945 2.946v9.434q0 .075-.01.146a1.002 1.002 0 0 1-.99 1.146zm-1-2V8.006H9.353v3.836zm-7.295 0V8.006H2.058v3.836zm-5.295 2h5.295v3.642h-4.35a.95.95 0 0 1-.945-.946zm14.132 2.33a1 1 0 0 1 1.414 0l2.316 2.315 2.315-2.315a1 1 0 0 1 1.415 1.414l-2.316 2.316 2.316 2.315a1 1 0 0 1-1.415 1.414l-2.315-2.315-2.316 2.315a1 1 0 0 1-1.414-1.414l2.316-2.316-2.316-2.315a1 1 0 0 1 0-1.414",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const TableDelete = { render };
export {
  TableDelete as default,
  render
};
//# sourceMappingURL=TableDelete.svg.js.map
